var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.77255 27.6056C2.31197 27.6047 1.85955 27.484 1.45979 27.2553C0.55961 26.7452 0 25.755 0 24.68V2.92571C0 1.84775 0.55961 0.860552 1.45979 0.350451C1.86907 0.115232 2.33402 -0.00572965 2.80605 0.000208569C3.27807 0.00614679 3.73983 0.138767 4.14307 0.384208L22.7355 11.5134C23.123 11.7564 23.4424 12.0938 23.6638 12.494C23.8852 12.8941 24.0014 13.344 24.0014 13.8014C24.0014 14.2587 23.8852 14.7086 23.6638 15.1088C23.4424 15.5089 23.123 15.8463 22.7355 16.0893L4.14007 27.2215C3.72741 27.471 3.25475 27.6037 2.77255 27.6056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.7b55735e5bbaa5602e9aa5b54ef2649d.svg";
export { ForwardRef as ReactComponent };